import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BACKEND_ORIGIN } from "../../utils/config/constants";
import "../Login/LoginPage.scss";
import "./OAuthConsentPage.scss";

/**
 * Страница согласий при входе через Яндекс.
 *
 * Бэкенд перенаправляет сюда, если OAuth-вход завершился бы без полученных
 * согласий (новый пользователь или пользователь без зафиксированных согласий).
 * После отметки обоих чекбоксов вход возобновляется с параметрами pd/cb.
 */
export function OAuthConsentPage() {
  const navigate = useNavigate();
  const [personalDataConsent, setPersonalDataConsent] = useState(false);
  const [crossBorderConsent, setCrossBorderConsent] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleContinue = () => {
    if (!personalDataConsent) {
      setError("Отметьте согласие на обработку персональных данных.");
      return;
    }
    if (!crossBorderConsent) {
      setError("Отметьте согласие на трансграничную передачу персональных данных.");
      return;
    }
    window.location.href = `${BACKEND_ORIGIN}/oauth2/authorization/yandex?pd=1&cb=1`;
  };

  return (
    <main className="login">
      <section className="login__card">
        <h1 className="login__title">Согласия для входа через Яндекс</h1>
        <p className="login__subtitle">
          Чтобы завершить вход через Яндекс, подтвердите согласия ниже — это займёт меньше минуты.
        </p>

        <div className="login__consents">
          <label className="login__consent">
            <input
              type="checkbox"
              checked={personalDataConsent}
              onChange={(event) => setPersonalDataConsent(event.target.checked)}
            />
            <span>
              Я даю согласие на обработку персональных данных в соответствии с <a href="/consent" target="_blank" rel="noopener noreferrer">Согласием на обработку персональных данных</a> и <a href="/privacy" target="_blank" rel="noopener noreferrer">Политикой обработки персональных данных</a>, а также принимаю <a href="/offer" target="_blank" rel="noopener noreferrer">Пользовательское соглашение</a>
            </span>
          </label>
          <label className="login__consent">
            <input
              type="checkbox"
              checked={crossBorderConsent}
              onChange={(event) => setCrossBorderConsent(event.target.checked)}
            />
            <span>
              Я даю согласие на трансграничную передачу моих персональных данных получателям из США, КНР и иных государств в соответствии с <a href="/cross-border-consent" target="_blank" rel="noopener noreferrer">Согласием на трансграничную передачу персональных данных</a> и <a href="/privacy" target="_blank" rel="noopener noreferrer">Политикой обработки персональных данных</a>
            </span>
          </label>
        </div>

        <div className="oauthConsent__actions">
          {error ? <p className="login__error">{error}</p> : null}

          <button className="login__submit" type="button" onClick={handleContinue}>
            Продолжить через Яндекс
          </button>
          <button className="login__back" type="button" onClick={() => navigate("/login")}>
            Вернуться ко входу
          </button>
        </div>
      </section>
    </main>
  );
}
